import React from 'react';
import { Flexbox, Icon, Tooltip } from '@hiiretail/synergy-ui';
import styled from 'styled-components';
import {
  TooltipProps,
} from '@hiiretail/synergy-ui/dist/types/components/surfaces/Tooltip/Tooltip.types';

const StyledQuestionMark = styled(Icon.QuestionmarkRound)`
  cursor: help;
`;

type InlineHintProps = Omit<TooltipProps, 'title'>;

export type InlineHintComponent = React.FC<InlineHintProps>;

export const InlineHint: InlineHintComponent = ({ children, ...props }) => {

  return (
    <Tooltip
      {... props}
      title={
        <Flexbox container direction="column" style={{ maxWidth: '30vw', color: 'white' }}>
          {children}
        </Flexbox>
      }
    >
      <StyledQuestionMark size="md" />
    </Tooltip>
  );
};
